import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ChipIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M8.66667 2V4.22222M15.3333 2V4.22222M8.66667 19.7778V22M15.3333 19.7778V22M4.22222 8.66667H2M4.22222 15.3333H2M22 8.66667H19.7778M22 15.3333H19.7778M6.44444 19.7778H17.5556C18.1449 19.7778 18.7102 19.5437 19.1269 19.1269C19.5437 18.7102 19.7778 18.1449 19.7778 17.5556V6.44444C19.7778 5.85507 19.5437 5.28984 19.1269 4.8731C18.7102 4.45635 18.1449 4.22222 17.5556 4.22222H6.44444C5.85507 4.22222 5.28984 4.45635 4.8731 4.8731C4.45635 5.28984 4.22222 5.85507 4.22222 6.44444V17.5556C4.22222 18.1449 4.45635 18.7102 4.8731 19.1269C5.28984 19.5437 5.85507 19.7778 6.44444 19.7778ZM8.66667 8.66667H15.3333V15.3333H8.66667V8.66667Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

ChipIcon.displayName = 'ChipIcon';
